<script lang="ts">
  export let title: string = "";
</script>

<h1>
  {@html title}
</h1>

<style lang="scss">
  h1 {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    text-align: inherit;
  }
</style>